import { Document, Image, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { ResponsibleDeclaration } from './ResponsibleDeclaration';

const styles = StyleSheet.create({
	page: { padding: 72 },
	title: { fontFamily: 'Helvetica', textAlign: 'center', fontSize: 16, marginBottom: 10, marginTop: 10 },
	text: { fontFamily: 'Helvetica', marginBottom: 10, fontSize: 10, lineHeight: 1.3 },
	listItem: { fontFamily: 'Helvetica', marginBottom: 10, fontSize: 10, lineHeight: 1.5, marginLeft: 20 },
	bold: { fontFamily: 'Helvetica-Bold'},	
	italic: {fontFamily: 'Helvetica-Oblique'}
});
// const B = ({ children }) => <Text style={{ fontWeight: 'bold' }}>{children}</Text>;
// const I = ({ children }) => <Text style={{ fontStyle: 'italic' }}>{children}</Text>;

export function ComEmpleo(props, signatureImg) {
	console.log('SIGNATURE IMG', signatureImg)
	return (
		<>
  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>Comunicación</Text>
                <Text style={styles.text}>
                    {props.fullName}, mayor de edad, de nacionalidad {props.citizenship1}, con domicilio en {props.address}, con pasaporte de mi país con número {props.passport} y con número de identidad de extranjero (en adelante, “NIE”) {props.nie}, comparezco ante esta Oficina de Extranjería y, como mejor proceda, DIGO:
                </Text>
                <Text style={styles.listItem}>
                    I. Que de conformidad con el artículo 105.3 del Real Decreto 557/2011, es requisito para solicitar autorización de trabajo por cuenta propia comunicar “la incidencia, en su caso, en la creación de empleo, incluyendo como tal el auto empleo” (sic).
                </Text>
                <Text style={styles.listItem}>
                    II. Que de conformidad con el artículo 69.2 de la Ley 39/2015, de 1 de octubre, se entiende por comunicación “aquel documento mediante el que los interesados ponen en conocimiento de la Administración Pública competente sus datos identificativos o cualquier otro dato relevante para el inicio de una actividad o el ejercicio de un derecho”.
                </Text>
                <Text style={styles.listItem}>
                    III. Que de conformidad con el artículo 69.3 de la Ley 39/2015, de 1 de octubre, “Las (...) comunicaciones permitirán, el reconocimiento o ejercicio de un derecho o bien el inicio de una actividad, desde el día de su presentación, sin perjuicio de las facultades de comprobación, control e inspección que tengan atribuidas las Administraciones Públicas”.
                </Text>
                <Text style={styles.listItem}>
					IV. Que, en virtud de todo ello, y bajo mi propia responsabilidad,</Text>
                <Text style={styles.title}>Comunico:</Text>
                <Text style={styles.text}>
                    Que, incluyendo el autoempleo, mi actividad económica proyectada generará {props.numJobs} empleos.
                </Text>
                <Text style={styles.text}>
                    Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.
                </Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>
            </View>
        </Page>
    </Document>
		</>
	)
}

export function ComExencionTasa(props, signatureImg) {
	return (
		<>
  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>Comunicación</Text>
                <Text style={styles.text}>
                    {props.fullName}, mayor de edad, de nacionalidad {props.citizenship1}, con domicilio en {props.address}, con pasaporte de mi país con número {props.passport} y con número de identidad de extranjero (en adelante, “NIE”) {props.nie}, comparezco ante esta Oficina de Extranjería y, como mejor proceda, DIGO:
                </Text>
                <Text style={styles.listItem}>
                    I. Que de conformidad con el artículo 105.3 del Real Decreto 557/2011, es requisito para solicitar autorización de trabajo por cuenta propia comunicar “Haber abonado la tasa relativa a la autorización de trabajo por cuenta propia”.
                </Text>
                <Text style={styles.listItem}>
                    II. Que, ello no obstante, el artículo 47.1 de la Ley Orgánica 4/200 establece que “No vendrán obligados al pago de las tasas por la concesión de las autorizaciones para trabajar los nacionales iberoamericanos, filipinos, andorranos, ecuatoguineanos, los sefardíes, los hijos y nietos de español o española de origen, y los extranjeros nacidos en España cuando pretendan realizar una actividad lucrativa, laboral o profesional, por cuenta propia”. 
                </Text>
                <Text style={styles.listItem}>
                    III. Que me encuentro en el ámbito del artículo 47.1 de la Ley Orgánica 4/2000, como acredito mediante la aportación de la documentación que considero oportuna.
                </Text>
                <Text style={styles.listItem}>
					IV. Que de conformidad con el artículo 69.2 de la Ley 39/2015, de 1 de octubre, se entiende por comunicación “aquel documento mediante el que los interesados ponen en conocimiento de la Administración Pública competente sus datos identificativos o cualquier otro dato relevante para el inicio de una actividad o el ejercicio de un derecho”.
				</Text>
                <Text style={styles.listItem}>
					V. Que de conformidad con el artículo 69.3 de la Ley 39/2015, de 1 de octubre, “Las (...) comunicaciones permitirán, el reconocimiento o ejercicio de un derecho o bien el inicio de una actividad, desde el día de su presentación, sin perjuicio de las facultades de comprobación, control e inspección que tengan atribuidas las Administraciones Públicas”.	
				</Text>
                <Text style={styles.listItem}>
					VI. Que, en virtud de todo ello, y bajo mi propia responsabilidad,
				</Text>

                <Text style={styles.title}>Comunico:</Text>
                <Text style={styles.text}>
					Que el artículo 47.1 de la Ley Orgánica 4/2000 me exime del pago de la tasa relativa a la autorización de trabajo por cuenta propia, es decir de la tasa 790-062, epígrafe 1.5.
Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.

                </Text>
                <Text style={styles.text}>
                    Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.
                </Text>
                <Text style={styles.text}><strong>%FIRMA</strong></Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>



            </View>
        </Page>
    </Document>
		</>
	)
}


export function DecResponsableAprovechamiento(props, signatureImg) {
	return (
		<>
  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>Declaración Responsable</Text>
                <Text style={styles.text}>
                    {props.fullName}, mayor de edad, de nacionalidad {props.citizenship1}, con domicilio en {props.address}, con pasaporte de mi país con número {props.passport} y con número de identidad de extranjero (en adelante, “NIE”) {props.nie}, comparezco ante esta Oficina de Extranjería y, como mejor proceda, DIGO:
                </Text>
                <Text style={styles.listItem}>
                    I. Que de conformidad con el artículo 199 del Real Decreto 557/2011, es requisito para solicitar la modificación de la situación de estancia por estudios, formación o prácticas a la situación de residencia y trabajo por cuenta propia haber superado dicha actividad con aprovechamiento.
                </Text>
                <Text style={styles.listItem}>
                    II. Que de conformidad con el precitado precepto, en su apartado 5, la modificación es susceptible de ser solicitada hasta sesenta días naturales antes de la finalización de la autorización de estancia cuya modificación se solicita.
                </Text>
                <Text style={styles.listItem}>
                    III. Que, en tanto en cuanto la duración de la autorización de estancia es determinada por la duración del programa de estudios, formación o prácticas de base (art. 37.3 del Real Decreto 557/2011), se entiende que la solicitud de modificación se puede plantear antes de la rigurosa finalización de dicha actividad.
                </Text>
                <Text style={styles.listItem}>
					IV. Que de conformidad con el artículo 69.1 de la Ley 39/2015, de 1 de octubre, se entiende por declaración responsable “el documento suscrito por un interesado en el que éste manifiesta, bajo su responsabilidad, que cumple con los requisitos establecidos en la normativa vigente para obtener el reconocimiento de un derecho o facultad o para su ejercicio, que dispone de la documentación que así lo acredita, que la pondrá a disposición de la Administración cuando le sea requerida, y que se compromete a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a dicho reconocimiento o ejercicio”.
				</Text>
                <Text style={styles.listItem}>
					V. Que de conformidad con el artículo 69.3 de la Ley 39/2015, de 1 de octubre, “Las declaraciones responsables (...) permitirán, el reconocimiento o ejercicio de un derecho o bien el inicio de una actividad, desde el día de su presentación, sin perjuicio de las facultades de comprobación, control e inspección que tengan atribuidas las Administraciones Públicas”.
				</Text>
                <Text style={styles.listItem}>
					VI. Que, en virtud de todo ello, y bajo mi propia responsabilidad,
				</Text>

                <Text style={styles.title}>Declaro:</Text>
                <Text style={styles.listItem}>
                    I. Que, siendo titular de autorización de estancia por estudios, formación o prácticas con vigencia hasta la fecha que consta en los ficheros de la Administración General del Estado, con base en actividad de estudios, formación o prácticas con fecha de terminación que consta en la documentación acreditativa de admisión que aporté en el expediente que dio lugar a aquella primera, SUPERARÉ o HE SUPERADO los estudios, la formación o las prácticas que dieron lugar a la autorización objeto de modificación.
                </Text>
                <Text style={styles.listItem}>
                    II. Que dispongo o dispondré de documentación que así lo acredite.
                </Text>
                <Text style={styles.listItem}>
                    III. Que pondré a disposición de la Administración dicha documentación cuando me sea requerida.
                </Text>
                <Text style={styles.listItem}>
					IV. Que me comprometo a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a la autorización de residencia solicitada.
				</Text>

                <Text style={styles.text}>
                    Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.
                </Text>
                <Text style={styles.text}><strong>%FIRMA</strong></Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>
            </View>
        </Page>
    </Document>
		</>
	)
}


export function DecRespAutorizacionesNinguna(props, signatureImg) {
	return (
		<>
  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>Declaración Responsable</Text>
                <Text style={styles.text}>
                    {props.fullName}, mayor de edad, de nacionalidad {props.citizenship1}, con domicilio en {props.address}, con pasaporte de mi país con número {props.passport} y con número de identidad de extranjero (en adelante, “NIE”) {props.nie}, comparezco ante esta Oficina de Extranjería y, como mejor proceda, DIGO:
                </Text>
                <Text style={styles.listItem}>
                    I. Que de conformidad con el artículo 105.3 del Real Decreto 557/2011, es requisito para solicitar autorización de trabajo por cuenta propia “Cumplir los requisitos que la legislación vigente exige a los nacionales para la apertura y funcionamiento de la actividad proyectada”.
                </Text>
                <Text style={styles.listItem}>
                    II. Que desde la Ley 12/2012, de 26 de diciembre, así como en virtud de la Ley 7/1985, de 2 de abril, mi actividad proyectada <Text style={styles.bold}>no está sujeta a requisitos específicos para la apertura y funcionamiento</Text>, más allá de las genéricas obligaciones de cursar alta en los regímenes correspondientes del Censo de Actividades y de la Seguridad Social, en su caso.
                </Text>
                <Text style={styles.listItem}>
                    III. Que, asimismo, la legislación vigente no me obliga a mantener local comercial para la realización de mi actividad económica.
                </Text>
                <Text style={styles.listItem}>
					IV. Que de conformidad con el artículo 69.1 de la Ley 39/2015, de 1 de octubre, se entiende por declaración responsable “el documento suscrito por un interesado en el que éste manifiesta, bajo su responsabilidad, que cumple con los requisitos establecidos en la normativa vigente para obtener el reconocimiento de un derecho o facultad o para su ejercicio, que dispone de la documentación que así lo acredita, que la pondrá a disposición de la Administración cuando le sea requerida, y que se compromete a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a dicho reconocimiento o ejercicio”.
				</Text>
                <Text style={styles.listItem}>
					V. Que de conformidad con el artículo 69.3 de la Ley 39/2015, de 1 de octubre, “Las declaraciones responsables (...) permitirán, el reconocimiento o ejercicio de un derecho o bien el inicio de una actividad, desde el día de su presentación, sin perjuicio de las facultades de comprobación, control e inspección que tengan atribuidas las Administraciones Públicas”.
				</Text>
                <Text style={styles.listItem}>
					VI. Que, en virtud de todo ello, y bajo mi propia responsabilidad,
				</Text>

                <Text style={styles.title}>Declaro:</Text>
                <Text style={styles.listItem}>
                    I. Que cumplo los requisitos que la legislación vigente exige a los nacionales para la apertura y funcionamiento de la actividad proyectada en tanto en cuanto las Leyes 12/2012, de 26 de diciembre, y 7/1985, de 2 de abril, así como normas jurídicas relacionadas, eximen de dichos requisitos, salvo, en su caso, la correspondiente alta en el Censo de Actividades Económicas y en la Seguridad Social, <Text style={styles.bold}>que me comprometo a cursar tan pronto como sea necesario</Text> y, en cualquier caso, dentro de un mes desde la notificación de concesión de autorización de residencia temporal y trabajo por cuenta propia.
                </Text>
                <Text style={styles.listItem}>
                    II. Que dispongo o dispondré de documentación que así lo acredite.
                </Text>
                <Text style={styles.listItem}>
                    III. Que pondré a disposición de la Administración dicha documentación cuando me sea requerida.
                </Text>
                <Text style={styles.listItem}>
					IV. Que me comprometo a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a la autorización de residencia solicitada.
				</Text>

                <Text style={styles.text}>
                    Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.
                </Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>
            </View>
        </Page>
    </Document>
		</>
	)
}

export function DecRespAutorizaciones(props, signatureImg) {
	return (
		<>
  <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Text style={styles.title}>A la Oficina de Extranjería en {props.province2}</Text>
                <Text style={styles.title}>Declaración Responsable</Text>
                <Text style={styles.text}>
                    {props.fullName}, mayor de edad, de nacionalidad {props.citizenship1}, con domicilio en {props.address}, con pasaporte de mi país con número {props.passport} y con número de identidad de extranjero (en adelante, “NIE”) {props.nie}, comparezco ante esta Oficina de Extranjería y, como mejor proceda, DIGO:
                </Text>
                <Text style={styles.listItem}>
                    I. Que de conformidad con el artículo 105.3 del Real Decreto 557/2011, es requisito para solicitar autorización de trabajo por cuenta propia “Cumplir los requisitos que la legislación vigente exige a los nacionales para la apertura y funcionamiento de la actividad proyectada”.
                </Text>
                <Text style={styles.listItem}>
                    II. Que aparte de las genéricas obligaciones de, en su caso, cursar alta en el Censo de Actividades Económicas y en el régimen correspondiente de la Seguridad Social, la legislación vigente exige las siguientes licencias, autorizaciones y/o requisitos para la apertura y funcionamiento de la actividad proyectada:
                </Text>
                <Text style={styles.listItem}>
                    III. Que de conformidad con el artículo 69.1 de la Ley 39/2015, de 1 de octubre, se entiende por declaración responsable “el documento suscrito por un interesado en el que éste manifiesta, bajo su responsabilidad, que cumple con los requisitos establecidos en la normativa vigente para obtener el reconocimiento de un derecho o facultad o para su ejercicio, que dispone de la documentación que así lo acredita, que la pondrá a disposición de la Administración cuando le sea requerida, y que se compromete a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a dicho reconocimiento o ejercicio”.
                </Text>
                <Text style={styles.listItem}>
					IV. Que de conformidad con el artículo 69.3 de la Ley 39/2015, de 1 de octubre, “Las declaraciones responsables (...) permitirán, el reconocimiento o ejercicio de un derecho o bien el inicio de una actividad, desde el día de su presentación, sin perjuicio de las facultades de comprobación, control e inspección que tengan atribuidas las Administraciones Públicas”.
				</Text>
                <Text style={styles.listItem}>
					V. Que, en virtud de todo ello, y bajo mi propia responsabilidad,
				</Text>

                <Text style={styles.title}>Declaro:</Text>
                <Text style={styles.listItem}>
                    I. <Text style={styles.bold}>Que me comprometo a cumplir con los requisitos que la legislación vigente exige a los nacionales para la apertura y funcionamiento de la actividad proyectada</Text>, y he solicitado o solicitaré las autorizaciones o licencias exigidas, <Text style={styles.bold}>comprometiéndome, en cualquier caso</Text>, a cursar alta en los correspondientes supuestos de Actividades Económicas y en la Seguridad Social.
                </Text>
                <Text style={styles.listItem}>
                    II. Que dispongo o dispondré de documentación que así lo acredite.
                </Text>
                <Text style={styles.listItem}>
                    III. Que pondré a disposición de la Administración dicha documentación cuando me sea requerida.
                </Text>
                <Text style={styles.listItem}>
					IV. Que me comprometo a mantener el cumplimiento de las anteriores obligaciones durante el período de tiempo inherente a la autorización de residencia solicitada.
				</Text>

                <Text style={styles.text}>
                    Y para que así conste y surta los efectos oportunos, lo firmo en {props.municipality} el {props.date}.
                </Text>
				<View style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<View style={{ marginTop: 20 }} />
					<Text style={styles.text}>{props.fullName}</Text>
					<Image src={signatureImg} style={{ width: 150, height: 75 }} />
				</View>
	
            </View>
        </Page>
    </Document>
		</>
	)
}

